import moment from "moment";

import instance from "../xhrService";

const baseUrl = "/api/weather";
const getBaseUrl = (a, b) => `${baseUrl}/${a}/${b}`;
const localStorageKey = "weather";

const weatherApi = {
  fetch: (latitude, longitude) => {
    return instance
      .get(getBaseUrl(latitude, longitude))
      .then(({ data }) => {
        weatherApi.store(data);
        
return data;
      })
      .catch(err => {
        console.log("err getting weather", err);
        weatherApi.clear();
        
return "error";
      });
  },

  index: () => {
    const weatherData = localStorage.getItem(localStorageKey);

    if (!weatherData) return [];

    // wrap in try-catch in case localStorage value gets corrupted
    try {
      const today = moment();

      // remove previous data
      const parsedData = JSON.parse(weatherData).filter(
        d => !moment.unix(d.time).isBefore(today, "day"),
      );

      return parsedData;
    } catch (error) {
      weatherApi.clear();

      return [];
    }
  },

  store: data => {
    localStorage.setItem(localStorageKey, JSON.stringify(data));
  },

  clear: () => {
    localStorage.removeItem(localStorageKey);
  },
};

export default weatherApi;
